import { createReducer } from '@reduxjs/toolkit';

import { getBuildByName } from './actions';

interface BuildState {
  id: string;
  status: string;
}

export interface State {
  [build: string]: BuildState;
}

const initialState: State = {};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getBuildByName.fulfilled, (draft, { payload }) => {
      const [builds, buildName] = payload;
      if (!builds || builds.length <= 0) {
        return;
      }

      const mostRecentBuild = builds[0];
      const buildStatus = {
        status: mostRecentBuild.status,
        id: mostRecentBuild.id,
      };

      draft[buildName] = buildStatus;
    });
});
